import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { signOutUserStart } from './../../redux/User/user.actions';
import { selectCartItemsCount } from './../../redux/Cart/cart.selectors';
import './styles.scss';

import { checkUserIsAdmin } from '../../Utils';

const mapState = (state) => ({
  currentUser: state.user.currentUser,
  totalNumCartItems: selectCartItemsCount(state)
});

const Header = props => {
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(false);
  const dispatch = useDispatch();
  const { currentUser, totalNumCartItems } = useSelector(mapState);
  const isAdmin = checkUserIsAdmin(currentUser);

  const signOut = () => {
    dispatch(signOutUserStart());
  };

  useEffect(() => {
    setActiveMenu(false);
  }, [location]);

  return (
    <header className="header">
      <div className="wrap">
        <div className="logo">
          <Link to="/">
            <h3>NextGen</h3>
          </Link>
        </div>
        <div>
        {/* <input
          type="text"
          placeholder="Search in NextGen..."
          className="searchInput"
          onFocus={() => {
            window.location.href = '/search';
          }}
          readOnly
        /> */}
        <div className="searchContainer">
        {/* Desktop Search Input */}
        <input
          type="text"
          placeholder="Search in NextGen..."
          className="searchInput hideOnMobile"
          onFocus={() => {
            window.location.href = '/search';
          }}
          readOnly
        />

        {/* Mobile Search Icon */}
        <i
          className="fa fa-search showOnMobile searchIcon"
          onClick={() => {
            window.location.href = '/search';
          }}
        />
      </div>

        </div>

        <div className="callToActions">
          <ul>

            {/* Search input instead of icon */}

            <li className="hideOnMobile">
              <Link to="/cart">
                {totalNumCartItems !== 0 ? (
                  <i className="fa fa-shopping-cart">
                    ({totalNumCartItems})
                  </i>
                ) : (
                  <i className="fa fa-shopping-cart"></i>
                )}
              </Link>
            </li>

            {currentUser && [
              <li key={1}>
                <Link to={isAdmin ? "/admin" : "/dashboard"}>
                  <i className="fa fa-user-circle"></i>
                </Link>
              </li>
            ]}

            {!currentUser && [
              <li key={2}>
                <Link to="/login">
                  <i className="fa fa-user-circle"></i>
                </Link>
              </li>
            ]}

          </ul>
        </div>
      </div>
    </header>
  );
};

Header.defaultProps = {
  currentUser: null
};

export default Header;
